import { Routes } from '@angular/router';
import { ReportList } from './report/report-list/report-list';
import { CreateReportTypeComponent } from './report/create-report-type/create-report-type';
import { ReportSections } from './report/report-sections/report-sections';
import { GenerateReport } from './report/generate-report/generate-report';
import { DocumentPreviewComponent } from './report/document-preview-component/document-preview-component';
import { ReportList as ReportListV2 } from './report/report-list-v2/report-list';
import { CreateReportTypeComponent as CreateReportTypeV2 } from './report/create-report-type-v2/create-report-type';
import { ReportSections as ReportSectionsV2 } from './report/report-sections-v2/report-sections';
import { GenerateReport as GenerateReportV2 } from './report/generate-report-v2/generate-report';
import { ReviewRefine } from './report/review-refine/review-refine';
import { CompileExport } from './report/compile-export/compile-export';
import { AuthGuard } from './auth/auth.guard';
import { v1MatchGuard, v2MatchGuard } from './auth/version.guard';
import { Unauthorized } from './unauthorized/unauthorized';
import { UpdateFromDataComponent } from './report/update-from-data/update-from-data';

export const routes: Routes = [
  { path: '', redirectTo: 'reports', pathMatch: 'full' },

  { path: 'reports', component: ReportList, canActivate: [AuthGuard], canMatch: [v1MatchGuard] },
  { path: 'report-types', component: CreateReportTypeComponent, canActivate: [AuthGuard], canMatch: [v1MatchGuard] },
  { path: 'report-sections', component: ReportSections, canActivate: [AuthGuard], canMatch: [v1MatchGuard] },
  { path: 'generate-report', component: GenerateReport, canActivate: [AuthGuard], canMatch: [v1MatchGuard] },
  { path: 'preview-report', component: DocumentPreviewComponent, canActivate: [AuthGuard] },

  //v2 routes
  { path: 'reports', component: ReportListV2, canActivate: [AuthGuard], canMatch: [v2MatchGuard] },
  { path: 'report-types', component: CreateReportTypeV2, canActivate: [AuthGuard], canMatch: [v2MatchGuard] },
  { path: 'report-sections', component: ReportSectionsV2, canActivate: [AuthGuard], canMatch: [v2MatchGuard] },
  { path: 'generate-report', component: GenerateReportV2, canActivate: [AuthGuard], canMatch: [v2MatchGuard] },
  // Screen 03 of the update-from-data flow: review & refine detected changes.
  { path: 'report-review', component: ReviewRefine, canActivate: [AuthGuard], canMatch: [v2MatchGuard] },
  // Screen 05 of the update-from-data flow: order the appendices, then export.
  { path: 'report-compile', component: CompileExport, canActivate: [AuthGuard], canMatch: [v2MatchGuard] },

  { path: 'update-report', component: UpdateFromDataComponent,canActivate: [AuthGuard], canMatch: [v2MatchGuard] },

  { path: 'unauthorized', component: Unauthorized },
];
